export default __webpack_public_path__ + "static/media/information-green-icon.dd7b46c1.svg";